export default __webpack_public_path__ + "static/media/cardOffersRetargeting.dda982b8.svg";